 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'doctorAdd'" @click="addData">新增</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">科室名称：</span>
                <el-input v-model="department_name" placeholder="科室名称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select
                    clearable
                    v-model="status" placeholder="请选择状态"  style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allStatus"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="sort" label="排序" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="100" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="department_name" label="科室名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" label="科室图片" align="center" label-class-name="label">
                <template slot-scope="scope">
                    <el-image :src="scope.row.licon" style="max-width: 24px; max-height: 24px">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <el-image :src="scope.row.licon_actived" style="max-width: 24px; max-height: 24px;margin-left: 2px;">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column width="240px" class-name="admin_user_name" prop="admin_user_name" label="特属服务专员" align="center" v-if="role_id != 2 && child_role_id == 0" label-class-name="label"></el-table-column>
            <el-table-column width="150" prop="doctor_number" label="特属专家数量" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="100" prop="sort" label="排序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200" prop="update_date" label="更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="360"
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button  @click="deleteData(scope.row)"
                           type="text" size="mini">删除
                </el-button>
                <el-button  @click="startStopHospitalDeparment(scope.row,2)"
                           v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button @click="startStopHospitalDeparment(scope.row,1)"
                           v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button  @click="gerAllDoctor(scope.row)"
                           type="text" size="mini">特属专家
                </el-button>
                <el-button  @click="addDoctor(scope.row)"
                           type="text" size="mini">添加特属专家
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck, isMobile} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        data() {
            return {
                role_id: 0,
                child_role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allStatus: [
                    {
                        id: 1,
                        name: '启用'
                    },
                    {
                        id: 2,
                        name: '停用'
                    },
                ],
                allHospital: [],
                department_name: '',
                status: '',
                hospital_id: '',
                is_submit: false,
                button_position: 'absolute',
                imgUrl: env.IMG_COMMON_URL_PREFIX,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
            }
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
                this.child_role_id = parseInt(userInfo.child_role_id)
            }
            if (this.$route.params.hospital_id) {
                this.hospital_id = this.$route.params.hospital_id;
            }
            localStorage.setItem('prev_page', 'newdepartment_list')
        },
        mounted() {
            // 获取科室列表
            this.getList();
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'hospitalDepartmentListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        department_name: this.department_name,
                        status: this.status,
                        hospital_id: this.hospital_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                        res.data.data.list[i].licon = this.imgUrl + res.data.data.list[i].icon
                        res.data.data.list[i].licon_actived = this.imgUrl + res.data.data.list[i].icon_actived
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.hospital_id = "";
                this.department_name = "";
                this.status = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "hospitalNewDeparmentEdit", params: {
                        id: data.id,
                        department_name: data.department_name,
                        sort: data.sort,
                        hospital_id: data.hospital_id,
                        icon: data.icon,
                        icon_actived: data.icon_actived,
                        status: parseInt(data.status_number),
                        company_id: data.company_id,
                        department_id: data.department_id,
                        group_id: data.group_id,
                        operate_user_ids: data.other_operate_users,
                        operate_user_id: data.operate_user_id,
                    }
                });
            },

            // 新增科室
            addData() {
                this.$router.push({name: "hospitalNewDeparmentAdd", params: {}});
            },

            deleteData(data) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定删除该科室吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminNewOperateServices',
                        method: 'deleteHospitalDepartment',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 启用停用公司
            startStopHospitalDeparment(data, status) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (status == '1') {
                    var message = '确定启用该科室吗？';
                }
                if (status == '2') {
                    var message = '确定停用该科室吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminNewOperateServices',
                        method: 'startStopHospitalDepartment',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 跳转到特属专家列表
            gerAllDoctor(data) {
                this.$router.push({
                    name: "doctorList", params: {
                        hospital_department_id: data.id
                    }
                });
            },

            // 跳转到添加特属专家
            addDoctor(data) {
                if (data.status_number == '2') {
                    this.$message.error('请先启用该数据！');
                    return;
                }
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/doctor/DoctorAdd', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "doctorAdd", params: {
                        hospital_department_id: data.id
                    }
                });
                return;
            },

            // 导出数据
            exportExcel() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'exportHospitalDepartment',
                    params: {
                        department_name: this.department_name,
                        status: this.status,
                        hospital_id: this.hospital_id,
                    },
                };
                let colums_list = [
                    {title: "ID", key: "id"},
                    {title: "科室名称", key: "department_name"},
                    {title: "特属专家数量", key: "doctor_number"},
                    {title: "更新时间", key: "update_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        this.is_submit = false;
                        return false;
                    }

                    for (let i = 0; i < res_data.data.length; i++) {
                        let status;
                        switch (res_data.data[i].status) {
                            case '1':
                                status = '启用';
                                break;
                            case '2':
                                status = '停用';
                                break;
                        }

                        let item = {
                            id: res_data.data[i].id,
                            department_name: res_data.data[i].department_name,
                            hospital_name: res_data.data[i].hospital_name,
                            doctor_number: res_data.data[i].doctor_number,
                            update_date: res_data.data[i].update_date,
                            status: status,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出科室");
                    let _that = this
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).finally(() => {
                    this.is_submit = false;
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-table .admin_user_name .cell{
        white-space: pre-wrap;
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-input {width: 100% !important;}
</style>
